// extracted by mini-css-extract-plugin
export var cartIcon = "_nw-0";
export var cartIconContainer = "_nw-1";